<template>
  <modal v-if="modalOpen" @close="close" @mask-click="close" :has-close-button="true" container-width="400px">
    <template slot="header">
      <h2>{{ $t('verification.title') }}</h2>
    </template>
    <template slot="body">
      <div class="container-fluid mt-3">
        <div class="row">
          <div class="col">
            <form-container :error-message="error" orientation="horizontal" >
              <p>{{ $t('verification.message') }}</p>
              <text-input v-bind="formItems.Code" v-model="formItems.Code.value" />
              <text-input v-bind="formItems.VerificationCode" v-model="formItems.VerificationCode.value" />
            </form-container>
          </div>
        </div>
      </div>
    </template>
    <template slot="footer">
      <loading-button :title="$t('verification.title')" @click="save" :is-busy="busySaving" :enabled="formItems.VerificationCode.value"/>
    </template>
  </modal>
</template>

<script>
import ModalComponent from 'components/ModalComponent.vue';
import formmixin from '@/forms/components.js';
import { FormControl, FormTextConfig } from 'libs/classes/form.js';
import SecurityController from 'controller/securitycontroller.js';

export default {
  mixins: [formmixin],
  components: {
    'modal': ModalComponent,
  },
  data() {
    return {
      modalOpen: false,
      formControl: null,
      formItems: null,
      busySaving: false,
      controller: new SecurityController(),
      error: null
    };
  },
  methods: {
    showModal(code) {
      this.loadForm(code);
      this.modalOpen = true;
    },
    close() {
      this.modalOpen = false;
    },
    async save() {
      this.busySaving = true;
      this.error = null;

      try {
        await this.controller.CheckVerificationCode(this.formItems.Code.value, this.formItems.VerificationCode.value);
        this.close();
        window.location.reload();
      } catch (error) {
        if (error.Error) {
          this.error = error.Error;
        } 
      } finally {
        this.busySaving = false;
      }
    },
    loadForm(code) {
      if (!this.formControl) {
        const form = new FormControl();
        form.add(new FormTextConfig('Code', this.$t('verification.code'), code, false, false));
        form.add(new FormTextConfig('VerificationCode', this.$t('verification.verification_code'), null, true, true));
        this.formControl = form;
        this.formItems = form.config;
      } else {
        this.formItems.Code.value = code;
        this.formItems.VerificationCode.value = null;
      }
    }
  }
};
</script>